module.exports = __webpack_public_path__ + "img/image-faceit.25d15899.jpg";